import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets"
)({
  loader: () => ({
    crumb: "Secrets",
  }),
});
